import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';
import { AdfoxContextProvider, TAdfoxContextProviderProps } from '../../context/AdfoxContext';
import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from '../../../../../constants';
import { AdBannerMicrofrontendFooterContainer } from '../../../../../containers/AdBannerMicrofrontendFooterContainer';
import { useApplicationContext } from '../../../../../containers/App/AppContext';

const POST_VIEW_ANALYTICS_DATA: TAdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'footer',
};
const P_PARAMS: TAdfoxContextProviderProps['pParams'] = { p1: 'dbtyp', p2: 'y' };
const SIZE: TAdfoxContextProviderProps['size'] = { width: '100%', height: 560 };

/**
 * Футерный баннер десктопной выдачи.
 *
 * Если манифест микрофронтенда ad-banner-frontend доехал до браузера (глобальный флаг
 * MarTech.AdBannerMicrofrontend.Enabled включён) — рендерим микрофронтенд, иначе остаётся
 * легаси-баннер на @cian/adfox-component с теми же параметрами размещения.
 */
export const AdfoxBannerFooterDesktop = React.memo(function AdfoxBannerMainPageFooter() {
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);

  const [isHidden, setIsHidden] = React.useState(false);
  const hide = React.useCallback(() => setIsHidden(true), []);

  if (manifest) {
    if (isHidden) {
      return null;
    }

    return <AdBannerMicrofrontendFooterContainer manifest={manifest} onStub={hide} onError={hide} onClose={hide} />;
  }

  return (
    <AdfoxContextProvider postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA} size={SIZE} pParams={P_PARAMS}>
      {() => <AdfoxBannerContainer />}
    </AdfoxContextProvider>
  );
});
